import {API_V1} from "../config/main-axios";

class Users {
  getAllUsers(data) {
    return API_V1.get("/accounts/admin/users/", {
      params: data
    })
  }

  createUser(data) {
    return API_V1.post("/accounts/admin/users/", data, {
      headers: {
        "Content-Type": "multipart/form-data",
      }
    })
  }

  getUserById(id) {
    return API_V1.get(`/accounts/admin/users/${id}/`)
  }

  updateStatus(data) {
    return API_V1.put(`/accounts/admin/users/update_status/`, data)
  }

  updateUser(id, data) {
    return API_V1.patch(`/accounts/admin/users/${id}/`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      }
    })
  }

  deleteUsers(ids) {
    return API_V1.delete("/accounts/admin/users/multiple_delete/", {
      data: {
        ids: ids
      },
      headers: {
        "Content-Type": "application/json",
      }
    })
  }

  getStudentList(id, data) {
    return API_V1.get(`/courses/performing/admin/courses/${id}/students/`, {
      params: data
    })
  }


  getUserQuestionsData(data) {
    return API_V1.get(`/accounts/admin/user-custom-field-value/`, {
      params: data
    })
  }

  submitQuestionsData(data) {
    return API_V1.patch("/accounts/admin/user-custom-field-value/partial_bulk_update/", data)
  }

  getFeedbacks(data) {
    return API_V1.get(`/feedbacks/admin/feedbacks/`, {
      params: data
    })
  }

  createFeedbacks(data) {
    return API_V1.post(`/feedbacks/admin/feedbacks/`, data)
  }
  updateFeedbacks(id,data) {
    return API_V1.patch(`/feedbacks/admin/feedbacks/${id}/`, data)
  }

  getUserFeedback(data) {
    return API_V1.get(`/feedbacks/admin/poll_answers/`, {
      params: data
    })
  }

  getExelOfUserFeedback(data) {
    return API_V1.get(`/feedbacks/admin/poll_answers/export_excel/`, {
      params: data,
      headers: {
        "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=utf-8",
        // Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=utf-8"
      },
      responseType: 'blob'
    })
  }

  getExcel(data) {
    return API_V1.get(`/accounts/admin/users/export_to_excel/`, {
      params: data,
      headers: {
        "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=utf-8",
        // Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=utf-8"
      },
      responseType: 'blob'
    })
  }

  getCountries() {
    return API_V1.get(`/locations/country/`)
  }

  getProvinces(data) {
    return API_V1.get(`/locations/province/`, {
      params: data
    })
  }
}

export default new Users();
